import React from "react";



const lightText = "#f4f5f7";
const dimText = "#d6dae2";
const labelText = "#b2bad2";




const PrivacyPolicy = () => (
  <main
    className="privacy-policy-page"
    style={{
      maxWidth: "820px",
      margin: "0 auto",
      padding: "2rem 1rem",
      fontFamily: "Inter, sans-serif",
      color: lightText,
      background: "transparent"
    }}
  >

<div style={{ margin: "1.2rem 0 2.5rem 0" }}>
      <a
        href="/"
        style={{
          display: "inline-flex",
          alignItems: "center",
          background: "rgba(140,153,253,0.12)",
          color: "#8c99fd",
          fontWeight: 500,
          borderRadius: "32px",
          fontSize: "1rem",
          padding: "8px 20px 8px 14px",
          textDecoration: "none",
          border: "1px solid #283360",
          boxShadow: "0 1px 7px 0 rgba(44,54,98,0.06)",
          transition: "background 0.15s,border 0.15s",
          gap: "0.6em",
        }}
      >
        <svg width="17" height="17" viewBox="0 0 18 18" fill="none" style={{ marginRight: 6 }} xmlns="http://www.w3.org/2000/svg">
          <path d="M11.25 14.25L6.75 9.75L11.25 5.25" stroke="#8c99fd" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        Back to Home
      </a>
    </div>


    <header style={{ marginBottom: "2.5rem" }}>
      <h1
        style={{
          fontSize: "2.3rem",
          fontWeight: 700,
          letterSpacing: "-0.025em",
          color: lightText
        }}
      >
        Privacy Policy
      </h1>
      <p style={{ color: dimText, fontSize: "1.1rem", marginTop: "0.5rem" }}>
        Effective Date: 24 April 2024
      </p>
      <p style={{ color: labelText, fontSize: ".97rem", marginTop: "0.7rem", lineHeight: 1.7 }}>
        This Privacy Policy explains how devyugal (“we”, “us”, or “our”) collects, uses, and protects your personal information when you use our website and services. By accessing devyugal.in or any affiliated platforms (“Site”), you agree to this Policy.
      </p>
    </header>

    <section style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontWeight: 700, fontSize: "1.3rem", color: lightText }}>1. Information We Collect</h2>
      <ul style={{ paddingLeft: "1.25rem", color: dimText, lineHeight: 1.7 }}>
        <li><b>Contact Information:</b> Name, email address, and phone number (when you contact us or fill a form).</li>
        <li><b>Business Details:</b> Company name, business requirements and project information you provide.</li>
        <li><b>Usage Data:</b> Pages visited, browser info, device IP, referral URLs, time/date of access (collected automatically via website analytics).</li>
        <li><b>Communication Records:</b> Emails or chats exchanged with us.</li>
      </ul>
    </section>

    <section style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontWeight: 700, fontSize: "1.3rem", color: lightText }}>2. How We Use Your Information</h2>
      <ul style={{ paddingLeft: "1.25rem", color: dimText, lineHeight: 1.7 }}>
        <li>To respond to your inquiries and deliver services you request.</li>
        <li>To improve our website, monitor systems, and analyze user interaction.</li>
        <li>To maintain security and prevent misuse or unauthorized access.</li>
        <li>For complying with any legal obligations.</li>
      </ul>
    </section>

    <section style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontWeight: 700, fontSize: "1.3rem", color: lightText }}>3. Sharing of Data</h2>
      <ul style={{ paddingLeft: "1.25rem", color: dimText, lineHeight: 1.7 }}>
        <li>We <b>do not sell</b> your personal information.</li>
        <li>We may share information with trusted service providers (e.g., web hosting, analytics vendors) for legitimate business needs. All such parties are bound by confidentiality and security obligations.</li>
        <li>We may disclose details if required by law or to protect our rights.</li>
      </ul>
    </section>

    <section style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontWeight: 700, fontSize: "1.3rem", color: lightText }}>4. Data Security</h2>
      <p style={{ color: dimText, lineHeight: 1.7 }}>
        We implement reasonable administrative, technical, and physical measures to protect your data. However, no system is fully secure — please contact us immediately if you believe your data has been compromised.
      </p>
    </section>

    <section style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontWeight: 700, fontSize: "1.3rem", color: lightText }}>5. Your Rights</h2>
      <ul style={{ paddingLeft: "1.25rem", color: dimText, lineHeight: 1.7 }}>
        <li>
          Request access, correction, or deletion of your data by emailing{" "}
          <a style={{ color: "#77aaff" }} href="mailto:yugal@devyugal.in">
            yugal@devyugal.in
          </a>.
        </li>
        <li>Opt out of marketing communications (if any) at any time.</li>
      </ul>
    </section>

    <section style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontWeight: 700, fontSize: "1.3rem", color: lightText }}>6. Cookies & Analytics</h2>
      <p style={{ color: dimText, lineHeight: 1.7 }}>
        We use browser cookies and analytics tools (like Google Analytics) to collect non-personal traffic data and usage patterns. You can control cookies through your browser settings.
      </p>
    </section>

    <section style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontWeight: 700, fontSize: "1.3rem", color: lightText }}>7. Third-party Links</h2>
      <p style={{ color: dimText, lineHeight: 1.7 }}>
        Our site may contain links to external sites. We are not responsible for their content or privacy practices. Please review their policies before providing information.
      </p>
    </section>

    <section style={{ marginBottom: "2rem" }}>
      <h2 style={{ fontWeight: 700, fontSize: "1.3rem", color: lightText }}>8. Children's Privacy</h2>
      <p style={{ color: dimText, lineHeight: 1.7 }}>
        Our services are not intended for children under 13. We do not knowingly collect or store information from anyone under 13 years of age.
      </p>
    </section>

    <section style={{ marginBottom: "3rem" }}>
      <h2 style={{ fontWeight: 700, fontSize: "1.3rem", color: lightText }}>9. Changes to this Policy</h2>
      <p style={{ color: dimText, lineHeight: 1.7 }}>
        We may update this policy as our practices or regulations evolve. Changes will be posted on this page with a revised effective date.
      </p>
    </section>

    <footer
      style={{
        color: "#a9b1c6",
        textAlign: "center",
        marginTop: "3rem",
        fontSize: "0.97rem"
      }}
    >
      <p>
        For questions or data requests, email{" "}
        <a href="mailto:yugal@devyugal.in" style={{ color: "#77aaff" }}>
          yugal@devyugal.in
        </a>
        .<br />
        © 2025 Yugal Raj Vimal · devyugal.in
      </p>
    </footer>
  </main>
);

export default PrivacyPolicy;